import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ReleaseNotesModal = ({ show, setShow, onDismissForever }) => {
    const { token } = useToken();
    const [loading, setLoading] = useState(false);

    const sprints = [
        { id: 33, name: 'Sprint 33', date: '29 Jul 2026', isCurrent: true }
        // { id: 32, name: 'Sprint 32', date: '15 Jun 2026', isCurrent: false },
        // { id: 31, name: 'Sprint 31', date: '01 May 2026', isCurrent: false }
    ];
    const [selectedSprint, setSelectedSprint] = useState(sprints[0]);

    const scrollToSprint = (sprint) => {
        setSelectedSprint(sprint);
        const element = document.getElementById(`sprint-${sprint.id}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        console.log("ReleaseNotesModal rendered with show=", show);
    }, [show]);

    const handleClose = () => {
        setShow(false);
    };

    const handleDismissForever = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/account/DismissReleaseNotes', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                toast.success('Preferencia guardada. No volveremos a mostrarte esto automáticamente.');
                setShow(false);
                if (onDismissForever) {
                    onDismissForever();
                }
            } else {
                toast.error('Error al guardar preferencia');
            }
        } catch (error) {
            console.error(error);
            toast.error('Error de red al guardar preferencia');
        }
        setLoading(false);
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered scrollable={true} contentClassName="border-0 shadow-lg overflow-hidden" className="release-notes-modal p-0">
            <style>
                {`
                .release-notes-modal .modal-content {
                    border-radius: 0.75rem;
                }
                .hover-bg-200:hover {
                    background-color: #e9ecef;
                }
                `}
            </style>
            <div className="d-flex flex-column flex-md-row" style={{ minHeight: '650px', maxHeight: '85vh' }}>
                {/* Sidebar */}
                <div className="bg-light p-4 d-flex flex-column border-end" style={{ width: '100%', maxWidth: '280px' }}>
                    <div className="mb-4 mt-2">
                        <span className="badge bg-primary px-2 py-1 fs--2 mb-3 shadow-sm" style={{ letterSpacing: '0.5px' }}>ADMINPANEL</span>
                        <h2 className="text-primary fw-bold mb-0" style={{ letterSpacing: '-0.5px' }}>Sprints</h2>
                    </div>
                    
                    <div className="flex-grow-1 mt-3">
                        {sprints.map(sprint => (
                            <div 
                                key={sprint.id}
                                onClick={() => scrollToSprint(sprint)}
                                className={`rounded p-3 mb-2 d-flex align-items-center justify-content-between cursor-pointer transition-base ${
                                    selectedSprint.id === sprint.id 
                                    ? 'bg-primary text-white shadow-sm' 
                                    : 'text-600 hover-bg-200'
                                }`}
                            >
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={sprint.isCurrent ? "check-circle" : "history"} className="me-3 fs-1" />
                                    <span className={`fs-0 ${selectedSprint.id === sprint.id ? 'fw-semi-bold' : ''}`}>
                                        {sprint.name}
                                    </span>
                                </div>
                                {sprint.isCurrent && (
                                    <span className="fs--2 fw-bold text-primary bg-white rounded-pill px-2 py-1 shadow-sm">ACTUAL</span>
                                )}
                            </div>
                        ))}
                    </div>
                    
                   
                </div>

                {/* Main Content */}
                <div className="flex-grow-1 d-flex flex-column bg-white position-relative" style={{ overflow: 'hidden' }}>
                    {/* Header */}
                    <div className="p-4 px-md-5 border-bottom d-flex justify-content-between align-items-center bg-white sticky-top" style={{ zIndex: 10 }}>
                        <div>
                            <div className="d-flex align-items-center text-primary mb-1">
                                <FontAwesomeIcon icon="code-branch" className="me-3 fs-2" />
                                <h3 className="mb-0 fw-bold fs-2">Adminpanel Release Notes</h3>
                            </div>
                            
                        </div>
                    </div>

                    {/* Content body */}
                    <div className="p-4 px-md-5 flex-grow-1" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                        
                        <div className="bg-light p-4 rounded-3 border position-relative">
                            {/* Timeline vertical line */}
                            <div className="position-absolute bg-300" style={{ top: '32px', bottom: '32px', left: '31px', width: '2px', zIndex: 0 }}></div>

                            <div id="sprint-33" className="mb-2 position-relative z-index-1">
                                <div className="d-flex align-items-start">
                                    <div className="mt-1 flex-shrink-0 bg-white" style={{ width: '16px', height: '16px', borderRadius: '50%', border: '4px solid #2c7be5', zIndex: 1 }}></div>
                                    <div className="ms-4 flex-grow-1">
                                        <h4 className="fw-bold fs-1 mb-1 d-flex align-items-center">
                                            Sprint 33 
                                            <span className="badge bg-success ms-3 fs--2 rounded-pill shadow-sm">Versión actual</span>
                                        </h4>
                                        <p className="text-500 fs--1 mb-4">29 Jul 2026</p>
                                        
                                        <ul className="list-unstyled mb-0">
                            
                            {/* NOVEDADES */}
                            <li className="d-flex flex-column flex-xl-row align-items-start mb-5 pb-4 border-bottom border-200">
                                <div className="mb-3 mb-xl-0 me-xl-4 text-xl-end" style={{ minWidth: '140px' }}>
                                    <span className="badge px-3 py-2 fs--2 rounded shadow-sm" style={{ backgroundColor: '#f3e8ff', color: '#7e22ce', letterSpacing: '0.5px' }}>NOVEDADES</span>
                                </div>
                                <div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Contabilidad]</strong>
                                        <span className="text-700 fs-0">Frontend completo para el catálogo de cuentas (estructura de árbol) y funcionalidad para eliminar cuentas.</span>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Facturación]</strong>
                                        <ul className="text-700 fs-0 mb-0 ps-3">
                                            <li className="mb-1">Soporte para facturas con tasa exenta y tasa cero. Documentos relacionados visibles en facturas.</li>
                                            <li className="mb-1">Nueva vista para "Pagos Recibidos" con más detalles, y tarjetas informativas en pagos emitidos.</li>
                                            <li>Nuevo panel de reporte para planes de facturación.</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <strong className="text-primary d-block mb-1">[Nóminas]</strong>
                                        <span className="text-700 fs-0">Funcionalidad para visualizar detalles de nóminas registradas.</span>
                                    </div>
                                </div>
                            </li>

                            {/* MEJORAS */}
                            <li className="d-flex flex-column flex-xl-row align-items-start mb-5 pb-4 border-bottom border-200">
                                <div className="mb-3 mb-xl-0 me-xl-4 text-xl-end" style={{ minWidth: '140px' }}>
                                    <span className="badge px-3 py-2 fs--2 rounded shadow-sm" style={{ backgroundColor: '#dcfce7', color: '#166534', letterSpacing: '0.5px' }}>MEJORAS</span>
                                </div>
                                <div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Logs]</strong>
                                        <span className="text-700 fs-0">Se modificó el servicio de logs de Akasia. Ahora en los detalles de licencia hay una nueva tabla donde se muestran los logs en caso de no ver información actual en la tabla anterior.</span>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Nube]</strong>
                                        <span className="text-700 fs-0">Al crear una licencia nube ya no es necesario seleccionar la base de datos, ahora el sistema lo hace automáticamente.</span>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Contabilidad]</strong>
                                        <ul className="text-700 fs-0 mb-0 ps-3">
                                            <li className="mb-1">Se estructuró y mejoró la lógica para importar archivos XML.</li>
                                            <li>El mes/periodo seleccionado ahora se guarda globalmente para mantener el contexto en las vistas contables.</li>
                                        </ul>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Nóminas]</strong>
                                        <span className="text-700 fs-0">Se mejoró la interfaz de la lista de nóminas.</span>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Facturación]</strong>
                                        <span className="text-700 fs-0">Rediseño del formulario de factura y nuevo modal de descarga de PDF.</span>
                                    </div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Desarrollo al sistema]</strong>
                                        <span className="text-700 fs-0">Restructuración de servicios Prodigia, actualización de endpoints (empresas y contabilidad), y archivo .bat para ejecución simultánea de proyectos.</span>
                                    </div>
                                    <div>
                                        <strong className="text-primary d-block mb-1">[Pagos]</strong>
                                        <span className="text-700 fs-0">Rediseño completo de la interfaz con nuevos componentes para una navegación más fluida.</span>
                                    </div>
                                </div>
                            </li>

                            {/* CORRECCIONES */}
                            <li className="d-flex flex-column flex-xl-row align-items-start mb-2">
                                <div className="mb-3 mb-xl-0 me-xl-4 text-xl-end" style={{ minWidth: '140px' }}>
                                    <span className="badge bg-primary px-3 py-2 rounded shadow-sm fs--2" style={{ letterSpacing: '0.5px' }}>CORRECCIONES</span>
                                </div>
                                <div>
                                    <div className="mb-3">
                                        <strong className="text-primary d-block mb-1">[Nóminas]</strong>
                                        <span className="text-700 fs-0">Se corrigieron y habilitaron los enlaces para descargar archivos XML y PDF directamente desde la lista general.</span>
                                    </div>
                                    <div>
                                        <strong className="text-primary d-block mb-1">[Facturación]</strong>
                                        <span className="text-700 fs-0">Se arregló y mejoró la generación del PDF de complementos de pago.</span>
                                    </div>
                                </div>
                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Plantilla para próximos Sprints:
                            <div id="sprint-32" className="mb-5 position-relative z-index-1">
                                <div className="d-flex align-items-start">
                                    <div className="mt-1 flex-shrink-0 bg-white" style={{ width: '16px', height: '16px', borderRadius: '50%', border: '4px solid #cbd0d9', zIndex: 1 }}></div>
                                    <div className="ms-4 flex-grow-1">
                                        <h4 className="fw-bold fs-1 mb-1">Sprint 32</h4>
                                        <p className="text-500 fs--1 mb-4">15 Jun 2026</p>
                                        <p className="text-700 fs-0">Aquí irá el contenido de las notas del Sprint 32...</p>
                                    </div>
                                </div>
                            </div>

                            <div id="sprint-31" className="mb-2 position-relative z-index-1">
                                <div className="d-flex align-items-start">
                                    <div className="mt-1 flex-shrink-0 bg-white" style={{ width: '16px', height: '16px', borderRadius: '50%', border: '4px solid #cbd0d9', zIndex: 1 }}></div>
                                    <div className="ms-4 flex-grow-1">
                                        <h4 className="fw-bold fs-1 mb-1">Sprint 31</h4>
                                        <p className="text-500 fs--1 mb-4">01 May 2026</p>
                                        <p className="text-700 fs-0">Aquí irá el contenido de las notas del Sprint 31...</p>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>
                    
                    {/* Footer */}
                    <div className="p-4 px-md-5 border-top bg-light d-flex justify-content-between align-items-center mt-auto">
                        <Button variant="outline-secondary" className="px-4 fw-semi-bold" onClick={handleDismissForever} disabled={loading}>
                            {loading ? 'Guardando...' : 'No volver a mostrar'}
                        </Button>
                        <Button variant="primary" className="px-5 shadow-sm fw-bold" onClick={handleClose} disabled={loading}>
                            Cerrar
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

ReleaseNotesModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    onDismissForever: PropTypes.func
};

export default ReleaseNotesModal;
